import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { servicesData } from '../servicesData';

const navItems = [
  { label: 'Home', href: '/' },
  {
    label: 'CA Services',
    href: '/services/gst-registration',
    dropdown: Object.entries(servicesData).map(([slug, d]) => ({ label: d.title, href: `/services/${slug}` })),
  },
  { label: 'GST', href: '/services/gst-registration' },
  { label: 'Company', href: '/services/company-registration' },
  { label: 'Tax Filing', href: '/services/income-tax-return' },
  { label: 'Trademark', href: '/services/trademark-registration' },
  { label: 'Blog', href: '/blog' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <nav className="sticky top-0 z-40 bg-white shadow-sm border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center text-white font-bold text-lg shadow">RP</div>
          <div className="leading-tight">
            <div className="font-extrabold text-[#0b3d5b] text-lg tracking-tight">Register Point</div>
            <div className="text-[10px] text-slate-500 uppercase tracking-wider">Tax &middot; Compliance &middot; Consulting</div>
          </div>
        </Link>
        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <div
              key={item.label}
              className="relative"
              onMouseEnter={() => item.dropdown && setOpenDropdown(item.label)}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <Link
                to={item.href}
                className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-orange-600 rounded transition-colors flex items-center gap-1"
              >
                {item.label}
                {item.dropdown && <ChevronDown className="w-3.5 h-3.5" />}
              </Link>
              {item.dropdown && openDropdown === item.label && (
                <div className="absolute top-full left-0 pt-1 z-50">
                  <div className="bg-white shadow-xl border border-slate-100 rounded-xl p-2 min-w-[250px]">
                    {item.dropdown.map((d) => (
                      <Link key={d.href} to={d.href} className="block px-3 py-2 text-sm text-slate-700 hover:bg-orange-50 hover:text-orange-600 rounded-lg transition-colors">
                        {d.label}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
          <Link to="/contact" className="ml-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-4 py-2 rounded transition-colors">
            Get Started
          </Link>
        </div>
        <button className="lg:hidden text-slate-700" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white max-h-[70vh] overflow-y-auto">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link key={item.label} to={item.href} onClick={() => setOpen(false)} className="px-2 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded">
                {item.label}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="mt-2 bg-orange-500 text-white text-center text-sm font-semibold px-4 py-2 rounded">
              Get Started
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
